import { render } from "./AboutComponent.vue?vue&type=template&id=0165fe98"
const script = {}

import exportComponent from "C:\\laragon\\www\\activa-nexus-contacto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__